import { useState } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { LANGUAGES } from "../i18n/translations";
import { useLang } from "../context/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-switcher-button"
        className="glass-pill flex items-center gap-2 px-4 py-2 text-sm text-white/90 hover:text-white transition"
      >
        <Globe className="w-4 h-4 text-amber-300" />
        <span className="font-medium tracking-wide">{current.flag}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div
            className="fixed inset-0 z-30"
            onClick={() => setOpen(false)}
            aria-hidden="true"
          />
          <div
            className="absolute right-0 mt-2 w-44 glass-card overflow-hidden z-40"
            data-testid="language-dropdown"
          >
            {LANGUAGES.map((l) => (
              <button
                key={l.code}
                data-testid={`language-option-${l.code}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left transition ${
                  l.code === lang
                    ? "bg-amber-300/15 text-amber-100"
                    : "text-white/80 hover:bg-white/10"
                }`}
              >
                <span className="font-mono text-xs text-amber-300/90 w-7">{l.flag}</span>
                <span>{l.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
